import React, { useMemo } from "react";

import useAdviceQuestionState, {
    IAdviceQuestionStateProps
} from "../hooks/useAdviceQuestionState";
import { SplitTreatments } from "@splitsoftware/splitio-react";
import { FeatureFlag } from "../../compare/enums/FeatureFlags";
import DapBlocker from "../components/DapBlocker";

export const AdviceControllerContext = React.createContext<
    ReturnType<typeof useAdviceQuestionState>
>(undefined);

const DigitalAdviceProvider: React.FC = (props) => {
    const getInitialState = (): IAdviceQuestionStateProps => {
        if (window.localStorage.getItem("dap_states")) {
            const json = JSON.parse(window.localStorage.getItem("dap_states"));
            return json;
        }
        return {
            sessionUserId: "",
            visitorId: "",
            questionList: [],
            baseImages: [],
            frameImages: [],
            finalRecommendedCover: {
                budget: {
                    client: {},
                    partner: {}
                },
                goals: {
                    client: {},
                    partner: {}
                },
                ultimate: {
                    client: {},
                    partner: {}
                }
            },
            frequencyAdviceAmount: [],
            nextQuestionOrder: null,
            previousQuestionId: null,
            quoteGroupIDs: {
                Interim: null,
                Budget: null,
                Goals: null,
                Ultimate: null
            }
        };
    };
    const adviceQuestionState = useAdviceQuestionState(getInitialState());

    const data = useMemo(() => ({ ...adviceQuestionState }), [adviceQuestionState]);

    return (
        <AdviceControllerContext.Provider value={data}>
            <SplitTreatments names={[FeatureFlag.DigitalAdvice]}>
                {({ treatments, isReady }) => {
                    if (!isReady) return null;

                    if (treatments[FeatureFlag.DigitalAdvice].treatment !== "on") {
                        return <DapBlocker />;
                    }
                    return <React.Fragment>{props.children}</React.Fragment>;
                }}
            </SplitTreatments>
        </AdviceControllerContext.Provider>
    );
};

export default DigitalAdviceProvider;
